import { FC, useCallback } from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { LockersMap } from "@modules/lockers-map";

import { OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";
import SectionTitle from "../common/SectionTitle";

const LockerSelectMap: FC = () => {
  const { t } = useTranslation();

  const {
    values: { [OrderFields.STARTING_COUNTRY]: startingCountry, [OrderFields.RETURN_LOCKER]: selectedLockerId },
    setValues,
  } = useOrderFormik();

  const handleLockerSelected = useCallback(
    (locker) => {
      setValues((oldValues) => ({
        ...oldValues,
        [OrderFields.RETURN_LOCKER]: locker.id,
        [OrderFields.RETURN_LOCKER_NAME]: locker.name,
      }));
    },
    [setValues]
  );

  return (
    <Box>
      <SectionTitle>{t("order-locker_map-closest_lockers_around_me")}</SectionTitle>
      <Box height="20rem" mt="0.5rem">
        <LockersMap
          countryCode={startingCountry!}
          selectedLockerId={selectedLockerId || undefined}
          onLockerSelect={handleLockerSelected}
          hasLockerPopups
          hasUserPosition
          hasPositionInit={false}
        />
      </Box>
    </Box>
  );
};
export default LockerSelectMap;
